import VueI18Next from '@panter/vue-i18next';
import { AbstractSideNavigationItem } from './types';

export const useLabelTranslation = (i18n: VueI18Next) => {
  const getTranslation = (item: AbstractSideNavigationItem) => {
    if (item.translate) return i18n.t(item.label);

    return item.label;
  };

  return getTranslation;
};
